import { Pipe, PipeTransform } from '@angular/core';
import { Promo } from '../models/entities/promo-entity';


@Pipe({
  name: 'promo-pipe'
})

export class PromoPipe implements PipeTransform {
  
  progressLevels = [  
    {'id' :    '0',  'name' : 'Proposée' },
    {'id' :   '10',  'name' : 'Validée'  },
    {'id' : '-100',  'name' : 'Fermée'   },
  ]

  transform(promo: Promo, field: string): any {

    let result = '';

    if (field == 'skipToSequence'){
      if (! promo.skipToSequence) {
        return '';
      } else {
        return promo.skipToSequence;
      }
    }

    if (field == 'amount'){
      if (! promo.amount) {
        return '';
      } else {
        return "<span  style='font-weight: bold, color: #198fb3'>" + Math.round(promo.amount * 100) /100 + '</span>';
      }
    }
    

    if (field == 'progressLevel'){
      switch (promo.progressLevel) {
        case 0:
          result = '<div class="label-orange">' + this.progressLevels[0].name + '</div>';
          break;
        case 10:
          result = '<div class="label-green">' + this.progressLevels[1].name + '</div>';
          break;
        case -100:
            result = '<div class="label-red">' + this.progressLevels[2].name + '</div>';
            break;
         default:
          result = '<div class="label-green">' +  promo.progressLevel + '</div>';
          break;
      }
    } 

    return result;
  }
}

